<template>
    <div class="ibox-tools d-flex" style="margin-top: auto; margin-bottom: 10px;">
        <div class="no-padding m-r-sm" style="min-width: 250px;">
            <select :data-placeholder="t_select_filter" class="chosen-select filter" name="existing_filter"
                    :aria-label="t_select_filter" style="border-radius: 4px; min-width: 250px;">
                <option v-for="element in filter" :value="element.id">{{ element.name }}</option>
            </select>
        </div>
        <v-btn v-if="current_selection_filter > 0"
                type="button" class="btn btn-secondary m-r-sm" @click.stop.prevent="editDeleteFilterModal">
            <i class="fa-regular fa-gear m-r-xs"></i>
            {{ t_edit_delete_filter }}
        </v-btn>
        <v-btn type="button" class="btn btn-w-m btn-primary" @click.stop.prevent="showAddFilterDialog">
            <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
            {{ t_new_filter }}
        </v-btn>
    </div>
</template>
<script>
    import fixAriaTag from "./searchBarWorkaround";

    export default {
        props: [
            'filter',
            'authSuperadmin',
            'selectedFilter',
        ],
        data() {
            return {
                t_edit_delete_filter: Lang.langGet("Edit / Delete Filter"),
                t_new_filter: Lang.langGet("New Filter"),
                t_select_filter: Lang.langGet("Select a filter..."),
                current_selection_filter: '',
                current_name_filter: ''
            }
        },
        watch: {
            filter: function (val, oldVal) {
                let changeVal = -1;
                let select = $(this.$el).find('.chosen-select.filter');

                if (val.length < oldVal.length) {
                    let found = false;

                    val.forEach((element) => {
                        if (parseInt(element['value']) === parseInt(this.selectedFilter)) {
                            found = true;
                        }
                    });

                    if (found === true) {
                        changeVal = this.selectedFilter;
                    } else {
                        this.current_selection_filter = '';
                        this.current_name_filter = '';
                    }
                } else {
                    changeVal = this.selectedFilter;
                }

                this.$nextTick(() => {
                    select.val(changeVal).trigger("chosen:updated");
                    if (changeVal === -1) {
                        this.current_selection_filter = '';
                        this.current_name_filter = '';
                    } else {
                        this.current_selection_filter = changeVal;
                        this.current_name_filter = select.find('option:selected').text();
                    }
                    EaseEventBus.fire('loadedClientJournalFilter');
                });

                EaseEventBus.fire('updateTable', {filter: changeVal});
            }
        },
        methods: {
            editDeleteFilterModal: function () {
                EaseEventBus.fire('clientJournalFilterEdit', {
                    name: this.current_name_filter,
                    id: this.current_selection_filter
                });
            },
            showAddFilterDialog: function () {
                EaseEventBus.fire('clientJournalFilterAdd');
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            }
        },
        mounted() {
            let selectFilter = $(this.$el).find('.chosen-select.filter');

            selectFilter.chosen().change(() => {
                this.current_selection_filter = parseInt(selectFilter.val());
                this.current_name_filter = selectFilter.find('option:selected').text();

                this.$emit('update:selectedFilter', this.current_selection_filter);
                EaseEventBus.fire('updateTable', {filter: selectFilter.val()});
                axios.get('/cache/clientjournalfilter/' + selectFilter.val());
            });

            fixAriaTag($(this.$el))

            EaseEventBus.listen('setNewClientJournalFilterAsCurrent', (data) => {
                this.filter.forEach((element) => {
                    if (element.name === data.name) {
                        selectFilter.val(_.toString(element.id)).trigger("chosen:updated");
                        this.current_selection_filter = selectFilter.val();
                        this.current_name_filter = selectFilter.find('option:selected').text();
                        EaseEventBus.fire('updateTable', {filter: selectFilter.val()});
                        axios.get('/cache/clientjournalfilter/' + selectFilter.val());
                    }
                })
            })
        }
    }
</script>
